import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { AccordionContent, AccordionItem, AccordionRoot, AccordionTrigger, cn } from "../..";
import { ContentLoader } from "../ContentLoader/ContentLoader";
export const FacetSkeletons = () => (<>
        {Array(3)
        .fill(0)
        .map((_, index) => (<div key={index} className="mb-5">
                    <ContentLoader className="mb-2.5 !h-10"/>
                    {Array(5)
            .fill(0)
            .map((_, index) => (<ContentLoader key={index} className="mb-2.5 !h-6"/>))}
                </div>))}
    </>);
const FacetExcessiveContext = createContext({
    display: () => false,
    Showmore: () => <></>,
    facet: null,
    searchable: false,
    searchValue: "",
    setSearchValue: () => { },
    attributes: [],
});
const useFacetSearch = (facet) => {
    const [searchValue, setSearchValue] = useState("");
    const searchable = useMemo(() => facet.facetsettings.issearchable && facet.attributes.length > facet.facetsettings.nrofshownattributes, [facet]);
    const attributes = useMemo(() => facet.attributes.filter((attribute) => {
        if (!searchable)
            return true;
        return attribute.title.toLowerCase().includes(searchValue.toLowerCase());
    }), [facet.attributes, searchable, searchValue]);
    return { searchValue, setSearchValue, searchable, attributes };
};
export const FacetProvider = ({ facet, children, className, expand, }) => {
    const [displayExcessiveItem, setDisplayExcessiveItem] = useState(false);
    const { attributes, searchable, searchValue, setSearchValue } = useFacetSearch(facet);
    const display = useCallback((index) => !(!displayExcessiveItem && index >= facet.facetsettings.nrofshownattributes), [displayExcessiveItem, facet.facetsettings.nrofshownattributes]);
    const Showmore = ({ className }) => attributes.length > facet.facetsettings.nrofshownattributes ? (<button type="button" onClick={() => setDisplayExcessiveItem((v) => !v)} className={className}>
                {displayExcessiveItem
            ? `${facet.facetsettings.collapsetext}...`
            : `${facet.facetsettings.expandtext}...`}
            </button>) : (<></>);
    return (<FacetExcessiveContext.Provider value={{ attributes, display, Showmore, facet, searchable, searchValue, setSearchValue }}>
            <AccordionRoot type="single" collapsible defaultValue={expand ? facet.facetsettings.attributename : ""}>
                <AccordionItem value={facet.facetsettings.attributename} className="text-black">
                    <AccordionTrigger className={cn(className, "font-normal uppercase")}>
                        {facet.facetsettings.title}
                    </AccordionTrigger>
                    <AccordionContent className="pb-2 pt-1.25 lg:pb-10">{children}</AccordionContent>
                </AccordionItem>
            </AccordionRoot>
        </FacetExcessiveContext.Provider>);
};
export const useFacetExcessive = () => useContext(FacetExcessiveContext);
